module.exports = __webpack_public_path__ + "img/1185z.2d81e5bb.png";